import { Text } from '@chakra-ui/react'
import type { FC } from 'react'
import { BaseButton } from '../buttons/BaseButton'
import { FlexCol } from '../flex'

const ExampleQuestion: FC<{ text: string; onClick: any; disabled: boolean }> = ({ text, onClick, disabled }) => {
  return (
    <BaseButton variant='secondary' onClick={onClick} isDisabled={disabled}>
      <Text color='#0A1D3D' fontSize={'12px'} fontWeight={500}>
        {text}
      </Text>
    </BaseButton>
  )
}

export const ExampleQuestions: FC<{ questions: string[]; onClick: any; disabled: boolean }> = ({ questions, onClick, disabled }) => {
  return (
    <FlexCol gap='12px'>
      {questions.map((question, idx) => (
        <ExampleQuestion key={`eq-${question}`} onClick={() => onClick(question)} text={question} disabled={disabled} />
      ))}
    </FlexCol>
  )
}
